import { type ReconcileSessionConstructor } from '@webapp/modules/accounts-payable/entities/ReconcileSession'
import { type ReconcileSessionApiModel } from '../api-models/ReconcileSessionApiModel'

export const mapReconcileSessionApiModel = (
  model: ReconcileSessionApiModel
): ReconcileSessionConstructor => ({
  id: model.id,
  uuid: model.uuid,
  status: model.status,
  balance: model.balance,
  statementDate: model.statement_date,
  lockStatus: {
    isLocked: model.lock_status.is_locked,
    lockedBy: model.lock_status.locked_by,
  },
  billUuid: model.bill_uuid,
  billGroup: model.bill_group,
  creditcardId: model.creditcard,
})
